module.exports = __webpack_public_path__ + "media/1x1/at-5ab33f74.svg";